/**
 * SignatureChip — tiny pill that renders the current DocuSign envelope status
 * next to a document name. Status values come straight from
 * `documents.signature_status` (null | sent | delivered | completed | declined).
 * Rendered inline so it can share a line with the doc title.
 */
import { CheckCircle2, Clock, Send, XCircle } from "lucide-react";

const MAP = {
  sent:       { label: "Sent",               icon: Send,         bg: "bg-blue-50",    fg: "text-blue-700",    ring: "ring-blue-200" },
  delivered:  { label: "Awaiting signature", icon: Clock,        bg: "bg-amber-50",   fg: "text-amber-700",   ring: "ring-amber-200" },
  completed:  { label: "Signed",             icon: CheckCircle2, bg: "bg-emerald-50", fg: "text-emerald-700", ring: "ring-emerald-200" },
  declined:   { label: "Declined",           icon: XCircle,      bg: "bg-rose-50",    fg: "text-rose-700",    ring: "ring-rose-200" },
};

export function SignatureChip({ status, testId }) {
  if (!status) return null;
  const cfg = MAP[status];
  if (!cfg) return null;
  const Icon = cfg.icon;
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-semibold ring-1 ring-inset ${cfg.bg} ${cfg.fg} ${cfg.ring}`}
      data-testid={testId}
    >
      <Icon className="h-3 w-3" />
      {cfg.label}
    </span>
  );
}
